import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Menu from "../components/Menu";

import api from "../services/api";

export default function HistoricoParada() {
    const [dataInicial, setDataInicial] = useState(new Date());
    const [dataFinal, setDataFinal] = useState(new Date());
    const [historico, setHistorico] = useState([]);

    const [id, setId] = useState(null);
    const [tempo, setTempo] = useState('');
    const [visible, setVisible] = useState(false);

    const toast = useRef(null);

    const showErrorMessage = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message })

    const handleClick = () => {
        if(dataInicial === null || dataFinal === null) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Preencha os campos "Data inicial" e "Data final" para prosseguir'
            });
            return;
        }

        let dataInicialFormatada = dataInicial.getFullYear() + '-' + (dataInicial.getMonth() + 1) + '-' + dataInicial.getDate();
        let dataFinalFormatada = dataFinal.getFullYear() + '-' + (dataFinal.getMonth() + 1) + '-' + dataFinal.getDate();
        let config = {};

        if(dataInicialFormatada !== dataFinalFormatada) {
            config.params = {
                filtrar_por_periodo: 1,
                data_inicial: dataInicialFormatada,
                data_final: dataFinalFormatada
            };
        }

        api.get(`cadastros/tear-parado/historico/${dataInicialFormatada}`, config).then((response) => {
            setHistorico(response.data);
            if(response.data.length === 0) {
                toast.current.show({
                    summary: 'Não encontrado',
                    severity: 'info',
                    detail: 'Nenhum registro encontrado para a data informada.'
                });
            } else {
                toast.current.show({
                    summary: 'Concluído',
                    severity: 'success',
                    detail: 'Histórico encontrado com sucesso.'
                });
            }
        }).catch((error) => {
            showErrorMessage(error);
        });
    }

    const handleUpdate = () => {
        if(id !== null && tempo !== '') {
            api.post('cadastros/tear-parado/update', {
                "id" : id,
                "tempo" : tempo,
            }).then((response) => {
                if(response.status === 200) {
                    toast.current.show({ summary: 'Concluído', severity: 'success', detail: response.data.message});
                    api.get(`cadastros/tear-parado/historico/${response.data.date}`).then((response) => {
                        setHistorico(response.data);
                    }).catch((error) => {
                        showErrorMessage(error);
                    });
                    onHide();
                }
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
    }

    const handleDelete = (rowData, rowIndex) => {
        confirmDialog({
            header: 'Confirmação',
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            message: 'Você tem certeza que deseja excluir esse registro?',
            accept: () => {
                api.post('cadastros/tear-parado/delete', {
                    'id': rowData.id
                }).then((response) => {
                    let copy = [...historico];
                    copy.splice(rowIndex, 1);
                    setHistorico(copy);

                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: response.data.message
                    });
                }).catch((error) => {
                    showErrorMessage(error);
                });
            }
        });
    }

    const onHide = () => {
        setTempo('');
        setVisible(false);
    }

    useEffect(() => {
        api.get('cadastros/tear-parado/historico').then((response) => {
            setHistorico(response.data);
        }).catch((error) => {
            showErrorMessage(error);
        });
    }, []);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card title="Histórico de Paradas" className="p-m-3">
                <div className="p-m-2">
                    <Calendar
                        dateFormat="dd/mm/yy"
                        onChange={e => setDataInicial(e.value)}
                        placeholder="Data inicial"
                        value={dataInicial}
                    />
                    <Calendar
                        className="p-ml-2"
                        dateFormat="dd/mm/yy"
                        onChange={e => setDataFinal(e.value)}
                        placeholder="Data final"
                        value={dataFinal}
                    />
                    <Button className="p-button-success" icon="pi pi-refresh" onClick={handleClick} />
                </div>

                <Dialog 
                    footer={() => (
                        <div>
                            <Button className="p-button-secondary" label="Cancelar" onClick={onHide} />
                            <Button className="p-button-success" label="Salvar" onClick={handleUpdate} />
                        </div>
                    )}
                    header="Editar" 
                    onHide={onHide} 
                    visible={visible}>
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="tempo">Tempo: </label>
                            <InputText 
                                onChange={e => {
                                    if((e.target.value.length < 4 && !/\D/g.test(e.target.value)) || e.target.value === '') {
                                        setTempo(e.target.value);
                                    }
                                }}
                                placeholder="Preencha o campo tempo"
                                value={tempo}
                            />
                        </div>
                    </div>
                </Dialog>

                <DataTable 
                    dataKey="id"
                    filterDisplay="row" 
                    paginator
                    responsiveLayout="scroll"
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    value={historico} 
                >
                    <Column header="ID" sortable field="id" />
                    <Column filter showFilterMatchModes={false} header="Parada" sortable field="parada" style={{ width: '15%', minWidth: '250px' }} />
                    <Column filter showFilterMatchModes={false} header="Grupo" sortable field="grupo" style={{ width: '15%', minWidth: '250px' }} />
                    <Column filter showFilterMatchModes={false} header="Tear" sortable field="tear" style={{ width: '15%', minWidth: '250px' }} />
                    <Column filter showFilterMatchModes={false} header="Turma" sortable field="turma" style={{ width: '15%', minWidth: '250px' }} />
                    <Column header="Tempo" field="tempo" />
                    <Column header="Data" field="data" />
                    <Column header="Hora" field="hora" />
                    <Column header="Ações" body={(rowData, rowIndex) => (
                        <div>
                            <Button className="p-button-primary p-mr-1" icon="pi pi-pencil" onClick={() => {
                                setId(rowData.id);
                                setTempo(rowData.tempo);
                                setVisible(true);
                            }} />
                            <Button className="p-button-danger p-ml-1" icon="pi pi-trash" onClick={() => handleDelete(rowData, rowIndex.rowIndex)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}
